import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { APPLICATION_MODE_NEW, APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE, LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION, ROUTE_PATH } from "../../app/constants";
import { ERROR_STRING } from "../../app/errors";
import { Button, ErrorMark, Header, Paragraph } from "../../components/RegularComponents";
import { setCompanyRjscDetails } from "../../redux/slice/rjscDetailReviewSlice";
import TopNavigationBar from "../TopNavigationBar";
import { applicationTypeFromLicenceSubType } from '../../redux/slice/applicationsUtils'
import { replaceUrlParams } from "../../app/utils";



const AgencyRJSCCompanyDetail = (props) => {
  const dispatch = useDispatch();

  const { isModal = false, onEditSave = () => {} } = props;

  const [rjscCompanyDetail, setRjscCompanyDetail] = useState("");
  const [showError, setShowError] = useState(false)

  const { applicationMode } = props.match.params

const { licencingSubType } = useSelector((state) => ({
  licencingSubType : state.primaryAgencyApplication.application?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
}));

const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
const isLender = (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE)
const isMortgageAdministrator = (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE)

  const companyRjscDetails = useSelector(
    (state) =>
      state.primaryAgencyApplication?.application?.businessLicenceData
        ?.companyRjscDetails ?? {}
  );

  const handleNext = () => {
    if(!rjscCompanyDetail) {
      setShowError(true)
      return
    }

    setShowError(false)

    const updatedCompanyRJSCData = {
      authorized: false,
      businessContact: {
        civicAddress: {
          city: "",
          postalCode: "",
          province: "",
          street: "",
        },
        email: null,
        fax: null,
        mailingAddress: {
          city: "",
          postalCode: "",
          province: "",
          street: "",
        },
        phoneNumber: null,
      },
      businessData: {
        businessOwner: "",
        companyType: "Business Name",
        companyTypeId: null,
        expiryDate: "",
        peopleList: [],
        phoneNumber: null,
        relatedTo: "",
      },
      businessEntity: {
        businessName: "",
        entityId: "",
        registryNumber: "",
      },
      order: 0,
      notRegistered: rjscCompanyDetail,
    };

    dispatch(
      setCompanyRjscDetails({
        ...companyRjscDetails,
        ...updatedCompanyRJSCData,
      })
    );

    if(isLender) {
      dispatch(
        !isModal
          ? push({
              pathname: `${ROUTE_PATH.ML_APP}${ROUTE_PATH.ML_RJSC_COMPANY_INFO}`,
            })
          : onEditSave()
      );
    }
    else if(isMortgageAdministrator){
      dispatch(
        !isModal
          ? push({
              pathname: `${ROUTE_PATH.MA_APP}${ROUTE_PATH.ML_RJSC_COMPANY_INFO}`,
            })
          : onEditSave()
      );
    }
    else {
      dispatch(
        !isModal
          ? push(replaceUrlParams(
                      ROUTE_PATH.RJSC_COMPANY_INFO,
                      applicationType,
                      applicationMode)
                  )
          : onEditSave()
      );
    }
  };

  return (
    <div className={!isModal ? "container" : ""}>
      {!isModal && (
        <>
          <TopNavigationBar {...props} 
                applicationType={applicationType} 
                applicationMode={APPLICATION_MODE_NEW}
            />
          {/* Title */}
          <div className="row">
            <div className="col-xs-12 col-lg-9">
              <Header
                id="ml-company-detail-header"
                header="Business not registered with the Nova Scotia Registry of joint Stock Companies (RJSC)"
              />
            </div>
          </div>
        </>
      )}

      <div className="row">
        <div className="col-xs-12 col-lg-9">
          <Paragraph
            id="ml-find-business-para"
            text={[
              "<b>Provide a reason why your company is not registered with RJSC</b>",
            ]}
          />
        </div>
      </div>

      <div className={"row"}>
        <div className={"col-9"}>
          <fieldset className="ns-fieldset">
            <div className={"ns-radios ns-radios--large"}>
              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  checked={rjscCompanyDetail === "soleProprietor"}
                  value={"soleProprietor"}
                  onChange={(e) => setRjscCompanyDetail(e.target.value)}
                  id={"rjsc-RJSCCompanyDetailsoleProprietor-input"}
                  name={"rjsc-RJSCCompanyDetailsoleProprietor-input"}
                />
                <label
                  id={"rjsc-RJSCCompanyDetailsoleProprietor-input-label"}
                  className="ns-radios__label"
                  htmlFor={"rjsc-RJSCCompanyDetailsoleProprietor-input"}
                >
                  <span className="ns-label-span">
                    I am a sole proprietor operating under my own name
                  </span>
                </label>
              </div>
              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  checked={rjscCompanyDetail === "not-for-profit"}
                  value={"not-for-profit"}
                  onChange={(e) => setRjscCompanyDetail(e.target.value)}
                  id={"rjsc-MLRJSCCompanyDetail-no-profit-input"}
                  name={"rjsc-MLRJSCCompanyDetail-no-profit-input"}
                />
                <label
                  id={"rjsc-MLRJSCCompanyDetail-no-profit-input-label"}
                  className="ns-radios__label"
                  htmlFor={"rjsc-MLRJSCCompanyDetail-no-profit-input"}
                >
                  <span className="ns-label-span">
                    My company is a federally registered not-for-profit
                  </span>
                </label>
              </div>

              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  checked={rjscCompanyDetail === "NB Exempt"}
                  value={"NB Exempt"}
                  onChange={(e) => setRjscCompanyDetail(e.target.value)}
                  id={"rjsc-RJSCCompanyDetail-nb-exempt-input"}
                  name={"rjsc-RJSCCompanyDetail-nb-exempt-input"}
                />
                <label
                  id={"rjsc-RJSCCompanyDetail-nb-exempt-input-label"}
                  className="ns-radios__label"
                  htmlFor={"rjsc-RJSCCompanyDetail-nb-exempt-input"}
                >
                  <span className="ns-label-span">
                    My company is registered in New Brunswick and is exempt from registering in Nova Scotia
                  </span>
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8 topMarginNormal">
          <div className={"help-block" + (showError ? " has-error" : "")}>
            <Button
              id="rjsc-search-button"
              text={!isModal ? "Next" : "Save and close"}
              buttonType={"regular_primary"}
              onClick={handleNext}
            />
            {showError && ErrorMark()}
            {showError && (
              <div className="ns-error-message topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.SELECT_COMPANY_RJSC_DETAIILS}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgencyRJSCCompanyDetail;
